<template>
  <div class="base-container">
    <FaqPanel
      page="reports"
      :top-offset="50"
      :max-width="350"
      :backdrop="true"
    />
    <el-main
      v-loading="loading"
      class="shadow"
      :class="{ 'p-none': isMobileViewport }"
    >
      <el-tabs
        v-model="activeTab"
        :before-leave="onTabLeave"
        @tab-change="onTabChange"
      >
        <slot :active-tab="activeTab" :job-id="jobId" />
      </el-tabs>
    </el-main>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import useRouter from '@/hooks/useRouter'
import useResize from '@/hooks/useResize'

import FaqPanel from '@/components/FaqPanel/Index.vue'

export default defineComponent({
  name: 'TabsContainer',
  components: {
    FaqPanel
  },
  props: {
    jid: {
      type: String,
      default: null
    },
    tab: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const { router } = useRouter()
    const { isMobileViewport } = useResize()

    const jobId = ref({ [props.tab]: props.jid })
    const activeTab = ref(props.tab)

    const onTabLeave = (tab: string) => {
      if (props.jid) {
        jobId.value[activeTab.value] = props.jid
      }
    }

    const onTabChange = (tab: string) => {
      if (jobId.value[tab]) {
        router.replace({
          name: 'reports-tab-result',
          params: { tab: tab, jid: jobId.value[tab] }
        })
      } else {
        router.replace({ name: 'reports-tab', params: { tab: tab } })
      }
    }

    return {
      isMobileViewport,
      activeTab,
      jobId,
      onTabChange,
      onTabLeave
    }
  }
})
</script>
